/* eslint-disable no-unused-vars */
import React, { useRef, useState, useEffect } from 'react'
import { Container, Breadcrumbs, Link, Grid } from '@material-ui/core'
import { ButtonHLPure, DialogSystemGLPure, SimpleLoading, DocumentDetailDataPure } from '../../pures'
import { DigitalVaultAlertsAction, DocumentPanelAction } from '../../actions'
import { useTranslation } from 'react-i18next'
import DocumentPanelBarBasicData from './document-panel-bar-basic-data'
import DocumentPanelBarVariables from './document-panel-bar-variables'
import DocumentPanelBarBinnacle from './document-panel-bar-binnacle'
import DocumentPanelBarAlerts from './document-panel-bar-alerts'
import DocumentPDF from './document-pdf'
import './digital-vault-document.view.css'
import DocumentPanelBarVersions from './document-panel-bar-versions.view'
import DocumentPanelBarExpediente from './document-panel-bar-expediente.view'
import Asn1DataTable from '../../pures/asn1Render/Asn1Render'
import { MediaPlayer } from '../../pures'
import DocumentPanelBarEntities from './document-panel-bar-entities'
import { DigitalVaultService, LocalStorageService } from '../../../services'
import { useParams } from 'react-router-dom'
import { useMediaQuery } from '@material-ui/core'

const DigitalVaultDocumentView = (props) => {
  let {
    toggleCompletedRequesting,
    toggleErrorRequesting,
    toggleLoadingRequesting,
    toggleWarning,
    isLoading,
    showLoadingRequesting,
    showErrorRequesting,
    showCompletedRequesting,
    showWarning,
    messageComplete,
    messageError,
    messageWarning,
    breadcrumbItems,
    handleBreadcrumbClick,
    setSelectedDocument,
    documentData,
    formatTransaction,
    formatPenaltyFee,
    showActions,
    showPDF,
    showPanelVaribales,
    showPanelBinnacle,
    showPrincipalView,
    showEditView,
    handleShowPrincipalView,
    showVersions,
    showExpediente,
    fileType,
    documentAlerts,
    showPanelEntities,
    titleDialog,
    openNewDocumentInView,
    isDeletingDocument = false
  } = props

  const breadcrumbRef = useRef()
  const { t } = useTranslation()

  const localStorageService = new LocalStorageService()

  const [description, setDescription] = useState('')
  const [transaction, setTransaction] = useState('$0.0')
  const [monetaryUnit, setMonetaryUnit] = useState('')
  const [penaltyFee, setPenaltyFee] = useState(false)
  const [confidentialCheck, setConfidentialCheck] = useState(false)
  const [obligatoryCheck, setObligatoryCheck] = useState(false)
  const [variableSelected, setVariableSelected] = useState({})
  const [binnacleSelected, setBinnacleSelected] = useState({})
  const [showAlerts, setShowAlerts] = useState(false)
  const [tags, setTags] = useState([])
  const [isEditing, setIsEditing] = useState(false)
  const [prefilledVariableValue, setPrefilledVariableValue] = useState(null)

  const [showDialogVersion, setShowDialogVersion] = useState(false)
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false)
  const [selectedAlert, setSelectedAlert] = useState(null)
  const [leaveWithoutChanges, setLeaveWithoutChanges] = useState(false)
  const [pendingExitEdit, setPendingExitEdit] = useState(false)
  const [isAIModalOpen, setIsAIModalOpen] = useState(false)

  const is960 = useMediaQuery('(max-width:960px)');

  const { id } = useParams()

  useEffect(() => {
    if (id && !props.documentData?.id && props.openNewDocumentInView) {
      props.openNewDocumentInView(null, id)
    }
  }, [id])

  useEffect(() => {
    if (!documentData && !documentData.tags) return
    setDescription(documentData.description)
    setConfidentialCheck(documentData.confidential)
    setObligatoryCheck(documentData.obligatory)
    setPenaltyFee(formatPenaltyFee)
    setTags(documentData.tags)
    setMonetaryUnit(documentData.monetaryUnit)
  }, [documentData, formatPenaltyFee])

  useEffect(() => {
    setTransaction(formatTransaction)
  }, [formatTransaction])


  const hanldeSubcategoryClick = (e) => {
    e.preventDefault()
    setSelectedDocument(null)
  }

  const handleChangeDescription = (e) => {
    let value = e.target.value
    setDescription(value)
  }

  const handleTransaction = (e) => {
    let value = e.target.value
    setTransaction(value)
  }

  const handleMonetaryUnit = (e) => setMonetaryUnit(e.target.value)

  const handlePenaltyFee = (e) => {
    let value = e.target.checked
    setPenaltyFee(value)
  }

  const onChangeCheckBoxConfidential = (e) => {
    let value = e.target.checked
    setConfidentialCheck(value)
  }

  const onChangeCheckBoxObligatory = (e) => {
    let value = e.target.checked
    setObligatoryCheck(value)
  }

  const documentDetailFields = [
    {
      field: documentData.infoType === process.env.REACT_APP_DIGITAL_VAULT_EXPEDIENTE
        ? t('digitalVaultDocumentView.name.record')
        : t('digitalVaultDocumentView.name.document'),
      value: documentData.name
    },
    {
      field: t('digitalVaultDocumentView.date'),
      value: documentData.startDate
    },
    {
      field: t('digitalVaultDocumentView.expirtation.date'),
      value: documentData.validationDate
    },
    {
      field: t('digitalVaultDocumentView.owner.document'),
      value: documentData.nameUser
    },
    {
      field: documentData.infoType === process.env.REACT_APP_DIGITAL_VAULT_EXPEDIENTE
        ? t('digitalVaultDocumentView.type.record')
        : t('digitalVaultDocumentView.type.document'),
      value: documentData.typeDocument,
      id: documentData.typeDocumentId
    },
    {
      field: t('digitalVaultDocumentView.confidential'),
      value: documentData.confidential
    },
    {
      field: t('digitalVaultDocumentView.description'),
      value: documentData.description
    },
    {
      field: t('digitalVaultDocumentView.tags'),
      value: Array.isArray(documentData.tags)
        ? documentData.tags
        : documentData.tags
          ? [{ text: String(documentData.tags), value: 0 }]
          : []
    },
    {
      field: t('digitalVaultDocumentView.summary.ia'),
      value: documentData.summary
    },
    {
      field: t('digitalVaultDocumentView.notifyExpiration'),
      value: documentData.notify
    }
  ]

  const handleShowDialogVersion = () => {
    setShowDialogVersion(true)
  }

  const handleCloseDialogVersion = () => {
    setShowDialogVersion(false)
    props.handleDeleteFile()
  }

  // Funciones para manejar alertas
  const handleSelectAlert = (alert) => {
    setSelectedAlert(alert)
  }

  const handleCreateAlert = (alertData) => {
    const newAlert = {
      id: Date.now(),
      ...alertData,
      active: true,
      createdDate: new Date().toISOString(),
      selected: false
    }
  }

  const detailsRef = useRef(null)

  if (isLoading) return <SimpleLoading />

  const currentPath = (typeof window !== 'undefined') ? (window.location.hash || window.location.pathname) : ''
  const isInDeleteFlow =
    currentPath.includes('papelera') ||
    currentPath.includes('bin') ||
    currentPath.includes('/digital-vault/bin') ||
    documentData?.status === process.env.REACT_APP_DOCUMENT_STATUS_ELIMINADO ||
    props.fromDelete === true

  const showBtnAddData = !isInDeleteFlow && documentData && documentData.typeDocument ? false : true

  const handleLocalRestoreDocument = async () => {
    try {
      toggleLoadingRequesting(true)

      const digitalVaultService = new DigitalVaultService(process.env.REACT_APP_MIFIRMA_API)
      const tokenData = localStorageService.getLocalStorageItem('token')
      const token = tokenData?.idToken
      if (!token) throw new Error('No se encontró token de autenticación')
      if (!isDeletingDocument) {
        await digitalVaultService.startDeleteWorkflow(documentData.id, false, token)
      } else {
        await digitalVaultService.nextDeleteWorkflowStep(documentData.id, token, false)
      }

      window.location.hash = '/'
    } catch (error) {
      console.error('Error al restaurar documento:', error)
      toggleErrorRequesting && toggleErrorRequesting('Error al restaurar el documento', 4000, false)
    } finally {
      toggleLoadingRequesting(false)
    }
  }

  const handleLocalDeletePermanently = async () => {
    try {
      toggleLoadingRequesting(true)
      const digitalVaultService = new DigitalVaultService(process.env.REACT_APP_MIFIRMA_API)
      const tokenData = localStorageService.getLocalStorageItem('token')
      const token = tokenData?.idToken
      if (!token) throw new Error('No se encontró token de autenticación')
      if (!isDeletingDocument) {
        await digitalVaultService.startDeleteWorkflow(documentData.id, true, token)
      } else {
        await digitalVaultService.nextDeleteWorkflowStep(documentData.id, token, true)
      }
      window.location.hash = '/'
    } catch (error) {
      console.error('Error al eliminar documento permanentemente:', error)
    } finally {
      toggleLoadingRequesting(false)
    }
  }

  const handleLocalGoBackToInbox = () => {
    if (props.goBack) return props.goBack()
    window.location.hash = '/'
  }

  const handleShowDeleteConfirmModal = () => setShowDeleteConfirmModal(true)
  const handleCloseDeleteConfirmModal = () => setShowDeleteConfirmModal(false)
  const handleConfirmDeletePermanently = () => {
    setShowDeleteConfirmModal(false)
    handleLocalDeletePermanently()
  }

  const handleBackBtn = async (e) => {
    if (documentData && documentData.infoType === process.env.REACT_APP_DIGITAL_VAULT_DOC_DE_EXP && documentData.name && documentData.parentDocument && documentData.parentDocument.name) {
      openNewDocumentInView(e, documentData.parentDocument.id)
    } else {
      // If user is editing, check for actual changes before prompting
      if (isEditing) {
        const hasChanges = await detailsRef.current?.hasChanges?.()
        if (hasChanges) {
          setLeaveWithoutChanges(true)
          return
        }
      }
      props.goBack()
    }
  }

  const handleStartEdit = () => {
    setIsEditing(true)
  }

  const handleSaveChanges = async () => {
    const success = await onSave()
    if (success) {
      setIsEditing(false)
    }
  }

  const handleCancelEdit = async () => {
    const hasChanges = await detailsRef.current?.hasChanges?.()
    if (hasChanges) {
      setPendingExitEdit(true)
      setLeaveWithoutChanges(true)
      return
    }
    setIsEditing(false)
  }

  const toggleEdit = async () => {
    if (!isEditing) {
      setIsEditing(true)
    } else {
      await handleCancelEdit()
    }
  }

  const onSave = async () => {
    try {
      toggleLoadingRequesting && toggleLoadingRequesting(true)
      const result = await detailsRef.current?.saveAll?.()
      if (result?.ok) {
        if (typeof setSelectedDocument === 'function') {
          const v = result.values || {}
          setSelectedDocument({
            ...documentData,
            name: v.name ?? documentData.name,
            description: v.description ?? documentData.description,
            startDate: v.startDate ?? documentData.startDate,
            validationDate: v.finishDate ?? documentData.validationDate,
            confidential: v.confidential ?? documentData.confidential,
            notify: v.notify ?? documentData.notify,
            typeDocument: v.typeDocument,
            tags: Array.isArray(v.tags) ? v.tags : documentData.tags,
            userId: v.ownerId ?? documentData.userId,
          })
        }
        return true
      }
      return false
    } catch {
      return false
    } finally {
      toggleLoadingRequesting && toggleLoadingRequesting(false)
    }
  }

  const showPanelsForOnlyDocument = documentData.infoType !== process.env.REACT_APP_DIGITAL_VAULT_EXPEDIENTE

  return (
    <Container disableGutters className='digitalVaultDocumentView'>
      {
        showAlerts ? (
          <DigitalVaultAlertsAction
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            documentIdProps={documentData.id}
            goBack={() => setShowAlerts(false)}
            t={t}
          />
        ) : (
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              disableGutters
              spacing={2}
            >
              <DocumentDetailDataPure
                ref={detailsRef}
                fieldValueArray={documentDetailFields}
                isEditing={isEditing}
                documentData={documentData}
                documentTypes={props.documentTypes}
              />
              {
                (showActions || (window.location.hash || window.location.pathname).includes('bin') ||
                  (window.location.hash || window.location.pathname).includes('papelera')) && (
                  <DocumentPanelAction
                    handleShowDialogVersion={handleShowDialogVersion}
                    handleCloseDialogVersion={handleCloseDialogVersion}
                    showDialogVersion={showDialogVersion}
                    setShowDialogVersion={setShowDialogVersion}
                    isEditing={isEditing}
                    onToggleEdit={toggleEdit}
                    onStartEdit={handleStartEdit}
                    onSaveChanges={handleSaveChanges}
                    onCancelEdit={handleCancelEdit}
                    onRequestSave={onSave}
                    handleReturn={handleBackBtn}
                    goBack={() => { window.location.hash = '/digital-vault/tracking' }}
                    isAIModalOpen={isAIModalOpen}
                    setIsAIModalOpen={setIsAIModalOpen}
                    {...props}
                  />
                )
              }
              {
                Array.isArray(breadcrumbItems) && breadcrumbItems.length > 0 &&

                <Breadcrumbs innerRef={breadcrumbRef} maxItems={4} itemsBeforeCollapse={2} itemsAfterCollapse={2} aria-label='Categorías'
                  className='digitalVaultDocumentView-breadcrumbs'
                >
                  {
                    breadcrumbItems.map((item, i) => <Link
                      href='#'
                      key={i}
                      onClick={(e) => {
                        setSelectedDocument(null)
                        handleBreadcrumbClick(e, item)
                      }}
                      aria-current='page'
                    >
                      {item.title}
                    </Link>)
                  }
                  {
                    (documentData && documentData.infoType === process.env.REACT_APP_DIGITAL_VAULT_DOC_DE_EXP && documentData.name && documentData.parentDocument && documentData.parentDocument.name) && (
                      <Link
                        href='#'
                        onClick={(e) => openNewDocumentInView(e, documentData.parentDocument.id)}
                        aria-current='page'
                      >
                        {documentData.parentDocument.name}
                      </Link>
                    )
                  }
                  {
                    documentData && (
                      <Link
                        href='#'
                        onClick={(e) => hanldeSubcategoryClick(e)}
                        aria-current='page'
                      >
                        {documentData.name}
                      </Link>
                    )
                  }
                </Breadcrumbs>

              }
            </Grid>
            {
              showPrincipalView && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  disableGutters
                  className='digitalVaultDocument-elemnts'
                >
                  <div className='digitalVaultDocument-panelBars'>
                    {
                      showExpediente && (
                        <DocumentPanelBarExpediente
                          isInDeleteFlow={isInDeleteFlow}
                          {...props}
                        />
                      )
                    }
                    {
                      showPanelsForOnlyDocument && <DocumentPanelBarAlerts
                        alerts={documentAlerts}
                        documentData={documentData}
                        showAlertsBtns={true}
                        isInDeleteFlow={isInDeleteFlow}
                        {...props}
                      />
                    }
                    {
                      showPanelsForOnlyDocument && showPanelVaribales && (
                        <DocumentPanelBarVariables
                          {...props}
                          isInDeleteFlow={showBtnAddData}
                          variableSelected={variableSelected}
                          setVariableSelected={setVariableSelected}
                          prefilledCreation={prefilledVariableValue}
                          onPrefillConsumed={() => setPrefilledVariableValue(null)}
                          source={'detailView'}
                        />
                      )
                    }
                    {
                      (showPanelsForOnlyDocument && showPanelEntities) && (
                        <DocumentPanelBarEntities
                          {...props}
                          isInDeleteFlow={isInDeleteFlow}
                          onUseEntity={(entity) => {
                            setPrefilledVariableValue({
                              value: entity?.name || '',
                              type: entity?.type,
                              entityId: entity?.id
                            })
                          }}
                        />
                      )
                    }
                    {
                      !showPanelsForOnlyDocument && <DocumentPanelBarAlerts
                        alerts={documentAlerts}
                        documentData={documentData}
                        showAlertsBtns={true}
                        isInDeleteFlow={isInDeleteFlow}
                        {...props}
                      />
                    }
                    {
                      showPanelsForOnlyDocument &&
                      (
                        <DocumentPanelBarVersions
                          isInDeleteFlow={isInDeleteFlow}
                          handleShowDialogVersion={handleShowDialogVersion}
                          {...props}
                        />
                      )
                    }
                    {
                      !showPanelsForOnlyDocument && showPanelBinnacle && (
                        <DocumentPanelBarBinnacle
                          {...props}
                          setBinnacleSelected={setBinnacleSelected}
                          type={documentData.infoType}
                        />
                      )
                    }
                  </div>
                  <div
                    className='digitalVaultDocument-pdf-actions'
                    style={{ '--pdfHeight': '825px' }}
                  >
                    {!is960 ?
                      (showPDF && fileType === 'pdf') ? (
                        !isAIModalOpen ? (
                          <DocumentPDF
                            {...props}
                          />
                        ) : <div className='documentPDF-container'></div>
                      )
                        : <>
                          {
                            fileType === process.env.REACT_APP_OCTET_STREAM_TYPE
                              ? <Asn1DataTable data={props.asn1Decode} />
                              : <MediaPlayer url={props.url} fileType={fileType} />
                          }
                        </>
                      : <></>}
                    {
                      showPanelsForOnlyDocument && showPanelBinnacle && (
                        <DocumentPanelBarBinnacle
                          {...props}
                          setBinnacleSelected={setBinnacleSelected}
                          type={documentData.infoType}
                        />
                      )
                    }
                    {is960 ?
                      (showPDF && fileType === 'pdf') ? (
                        !isAIModalOpen ? (
                          <DocumentPDF
                            {...props}
                          />
                        ) : <div className='documentPDF-container'></div>
                      )
                        : <>
                          {
                            fileType === process.env.REACT_APP_OCTET_STREAM_TYPE
                              ? <Asn1DataTable data={props.asn1Decode} />
                              : <MediaPlayer url={props?.url} fileType={fileType} />
                          }
                        </>
                      : <></>}
                  </div>
                  {
                    isInDeleteFlow ? (
                      <div className='digitalVaultDocument-bottom-actions'>
                        <ButtonHLPure
                          nameBtn={t('digitalVaultBinView.grid.btns.restore')}
                          onClickBtn={isDeletingDocument ? undefined : handleLocalRestoreDocument}
                          disabled={isDeletingDocument}
                          title={isDeletingDocument ? t('digitalVaultBinView.tooltip.deletingFlow') : undefined}
                        />
                        <ButtonHLPure
                          nameBtn={t('digitalVaultBinView.grid.btns.delete')}
                          primary={false}
                          onClickBtn={isDeletingDocument ? undefined : handleShowDeleteConfirmModal}
                          disabled={isDeletingDocument}
                          title={isDeletingDocument ? t('digitalVaultBinView.tooltip.deletingFlow') : undefined}
                        />
                        <ButtonHLPure
                          nameBtn={t('button.return')}
                          primary={false}
                          onClickBtn={handleLocalGoBackToInbox}
                        />
                      </div>
                    ) : (
                      props.goBack && (
                        <div className='digitalVaultDocument-back'>
                          <ButtonHLPure
                            nameBtn={t('button.return')}
                            onClickBtn={(e) => handleBackBtn(e)}
                          />
                        </div>
                      )
                    )
                  }
                </Grid >
              )
            }
            {
              showEditView && (
                <Grid
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  disableGutters
                  spacing={2}
                  className='digitalVaultDocument-editView-elements'
                >
                  <ButtonHLPure
                    nameBtn={t('button.return')}
                    primary={false}
                    onClickBtn={(e) => handleShowPrincipalView(e)}
                  />
                </Grid>
              )
            }
          </Grid >
        )
      }
      <DialogSystemGLPure
        showLoadingRequesting={showLoadingRequesting}
        showCompletedRequesting={showCompletedRequesting}
        showErrorRequesting={showErrorRequesting}
        showWarningRequesting={showWarning}
        toggleLoadingRequesting={toggleLoadingRequesting}
        toggleCompletedRequesting={toggleCompletedRequesting}
        toggleErrorRequesting={toggleErrorRequesting}
        toggleWarningRequesting={toggleWarning}
        message={messageError}
        messageComplete={t(messageComplete)}
        messageWarning={messageWarning}
        titleDialog={t(titleDialog)}
      />

      {
        showDeleteConfirmModal && (
          <DialogSystemGLPure
            showConfirm={true}
            confirmTitle={t('dialogSystemGLPure.confirmPermanentDelete.title')}
            confirmMessage={t('dialogSystemGLPure.confirmPermanentDelete.message')}
            labelCancelConfirmation={t('button.cancel')}
            labelSubmitConfirmation={t('button.delete')}
            handleConfirmDeleteFlowClose={handleCloseDeleteConfirmModal}
            handleConfirmDeleteFlowSubmit={handleConfirmDeletePermanently}
          />
        )
      }
      {
        leaveWithoutChanges && (
          <DialogSystemGLPure
            showConfirm={true}
            confirmTitle={t('digitalVaultDocumentView.edit.warning.title')}
            confirmMessage={t('digitalVaultDocumentView.edit.warning.content')}
            labelCancelConfirmation={t('button.save.dont')}
            labelSubmitConfirmation={t('button.save.changes')}
            handleConfirmDeleteFlowClose={async () => {
              setLeaveWithoutChanges(false)
              if (pendingExitEdit) {
                // Discard changes: reset child state and exit edit mode
                await detailsRef.current?.resetAll?.()
                setPendingExitEdit(false)
                setIsEditing(false)
              } else {
                // Discard and navigate back
                props.goBack()
              }
            }}
            handleConfirmDeleteFlowSubmit={async () => {
              setLeaveWithoutChanges(false)
              const ok = await onSave()
              if (ok) {
                if (pendingExitEdit) {
                  setPendingExitEdit(false)
                  setIsEditing(false)
                } else {
                  props.goBack()
                }
              }
            }}
          />
        )
      }
    </Container >

  )
}

export default DigitalVaultDocumentView